import { JsonObject } from "json2typescript";
import { FixedperiodsInterfece } from "../interfaces/fixedperiods.interface";

@JsonObject("Fixedperiods")
export class Fixedperiods implements FixedperiodsInterfece {
    Name?: string;
    Period?: string;
    PeriodEndDate?: string;
    PeriodInitialtDate?: string;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}